<template>
  <v-container class="mx-0 pt-4 px-0 template-message" fluid>
    <div style="max-height: 320px; overflow-y: auto; overflow-x: hidden">
      <mf-search v-model="searchCampaign" hide-details placeholder="Busque por campanhas" />
      <v-row>
        <v-col>
          <select-campaigns-table v-model="campaigns" :search="searchCampaign" :mode="mode" :status="status" show-message single-checkbox />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import SelectCampaignsTable from '@/components/select-campaigns/SelectCampaignsTable.vue'

export default {
  name: 'TemplateMessageCampaigns',
  components: {
    SelectCampaignsTable,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    mode: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    searchCampaign: '',
    status: ['ACTIVE', 'FINISHED', 'SCHEDULED'],
  }),
  computed: {
    campaigns: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<style lang="scss">
.template-message {
  padding-top: 17px !important;
}
</style>
